module.exports = __webpack_public_path__ + "img/send-offer-button-desktop-en.71fa9cf5.jpg";